module.exports = __webpack_public_path__ + "static/media/logos-print-h-arm.d0fca57b.jpg";